import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	changesApplyToAllPlans: {
		id: 'portfolio-3-dependency-settings.ui.footer.changes-apply-to-all-plans',
		defaultMessage: 'Changes to the dependencies configuration will apply to all existing plans.',
		description: 'Label to inform the users that the dependencies changes will apply to all plans',
	},
});
